export const NAME_COLUMN_WIDTH = 30;
export const ADDRESS_COLUMN_WIDTH = 20;
export const SHARED_MENU_COLUMN_WIDTH = 20;
export const CITY_COLUMN_WIDTH = 20;
export const SHARED_MENU_NAME_MAX_LENGTH = 50;

export const GOOGLE_SHEETS_PAGE_PATH = 'google-sheets-import';
export const BULK_IMAGE_UPLOAD_PAGE_PATH = 'bulk-image-upload';
export const TRANSLATIONS_PAGE_PATH = 'translations';
export const IMAGE_GALLERY_PAGE_PATH = 'image-gallery';
export const ADD_CATEGORIES_PATH = 'add-categories';

export const languageToPhraseKeyMap: { [key in Language]: string } = {
  ar: 'languages.ar',
  'ar-IL': 'languages.ar-IL',
  az: 'languages.az',
  cs: 'languages.cs',
  da: 'languages.da',
  de: 'languages.de',
  ee: 'languages.ee',
  el: 'languages.el',
  en: 'languages.en',
  et: 'languages.et',
  fi: 'languages.fi',
  fr: 'languages.fr',
  he: 'languages.he',
  hr: 'languages.hr',
  hu: 'languages.hu',
  is: 'languages.is',
  ja: 'languages.ja',
  ka: 'languages.ka',
  lt: 'languages.lt',
  lv: 'languages.lv',
  nb: 'languages.nb',
  pl: 'languages.pl',
  ru: 'languages.ru',
  sk: 'languages.sk',
  sl: 'languages.sl',
  sq: 'languages.sq',
  sr: 'languages.sr',
  sv: 'languages.sv',
  uz: 'languages.uz',
};

export const getUrlEstFaqLm = (lang: string) => `https://explore.wolt.com/${lang}/est/merchants/faq/listing-manager`;
